import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useNavigate, useParams } from "react-router-dom";
import { Avatar, Tooltip } from "@mui/material";

import { TableColumnProps, TablePage } from "components/alove/TablePage";
import { getProfileMatchScores, getByUserId, getNamesAsync } from "utils/enduserUtils";
import { EndUser } from "models/profile/EndUser";
import { Profile, ProfileAsset } from "models/profile/Profile";
import { avatarUrl, formatDate, formtHeight } from "utils/globalsUtils";
import { MatchScore } from "models/introduction/matchScore";
import { SMEHeader } from "layouts/itemPageContainer/userItem/profileHeader";
const { useMaterialUIController } = require("context");
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { UserName } from "components/alove/UserName";
import { Attribute } from "models/profile/Attribute";
import { getAttributes } from "utils/attributesUtil";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
const MDInput = require("components/MDInput/index.js").default;
const MDAvatar = require("components/MDAvatar/index.js").default;
const MDButton = require("components/MDButton/index.js").default;
const MDTypography = require("components/MDTypography/index.js").default;
import { PageNumber } from "../../../accessNumbers";

function EndUsersMatchScores() {
  const pageNumber = PageNumber.ViewEndUser;
  // const [controller, dispatch] = useMaterialUIController();

  const [attributes, setAttributes] = useState([] as Attribute[]);
  // const [relations, setRelations] = useState([] as BioPrefRelation[]);
  const [profile, setProfile] = useState<{
    user: EndUser;
    profile: Profile;
    profileAssets: ProfileAsset[];
  }>();

  useEffect(() => {
      getAttributes().then((res) => {
        setAttributes(res);
      }
    );
  }, []);

  // const { currentBrand, currentHost, currentRole } = controller;
  const navigate = useNavigate();

  // const partnerBioCell = (params) => {
  //   const bioAttr = findBioFromPref(attributes,  params.row.dealBreakerReason, relations);
  //   const p =
  //     params.row.isDealBreaker === MatchScoreDB.Responder ? profile?.profile : params.row.profile;
  //   const values = bioAttr?.map((attr) => p.attributesValues[attr.name]?.[0]);
  //   if (params.row.dealBreakerReason === "heightPref") {
  //     return formtHeight(values[0]);
  //   }
  //   if (params.row.dealBreakerReason === "prefAge") {
  //     return formatAge(values[0]);
  //   }
  //   return tr(values?.join(", ") || "");
  // };

  // const renderPrefCell = (params) => {
  //   const p =
  //     params.row.isDealBreaker === MatchScoreDB.Initiator ? profile?.profile : params.row.profile;

  //   if (params.row.dealBreakerReason === "heightPref") {
  //     return (
  //       formtHeight(p?.attributesValues[params.row.dealBreakerReason]?.[0]) +
  //       " - " +
  //       formtHeight(p?.attributesValues[params.row.dealBreakerReason]?.[1])
  //     );
  //   }

  //   return (
  //     p?.attributesValues[params.row.dealBreakerReason]?.map((v) => tr(v?.toString())).join(", ") ||
  //     ""
  //   );
  // };

  let { id } = useParams();
  const [lastSearch, setLastSearch] = useState("");

  useEffect(() => {
    getByUserId(id!).then((data) => {
      setProfile({
        user: Object.assign(new EndUser(), data.user),
        profile: Object.assign(new Profile(), data.profile),
        profileAssets: data.profileAssets,
      });
    });
  }, [id]);

  const getProfileMS = async ( filter, page) => {
    const profiles = await getProfileMatchScores(id!, filter, page);
    getNamesAsync(profiles.map((p) => p.profile!.userId!));
    setLastSearch(formatDate(profiles[0]?.createdAt));
    return profiles;
  };

  const formatDBKeys = (keys) => {
    if (!keys) return "";
    return keys.map((k) => attributes.find((a) => a.name === k)?.txt || k).join(", ");
  };


  const columns: TableColumnProps<MatchScore>[] = [
    {
      headerName: "",
      field: "initiatorUserAvatar",
      renderCell: (params) => (
        <Grid container alignItems="center" height="100%">
          <Avatar src={avatarUrl(params.row.profile.profileId, params.row.profileImage?.uri)} />
        </Grid>
      ),
    },
    {
      headerName: "Potential",
      field: "initiatorUser",
      renderCell: (params) => <UserName userId={params.row.profile.userId} />,
    },
    {
      field: "bodyType",
      headerName: "Body Type",
      renderCell: (params) => params.row.profile.attributesValues["bodyType"]?.[0],
      flex:1
    },
    {
      field: "initiatorBioScore",
      headerName: "Initiator Bio Score",
      flex:1
    },
    {
      field: "responderBioScore",
      headerName: "Responder Bio Score",
      flex:1
    },
    {
      field: "predictorScore",
      headerName: "Predictor Score",
      flex:1
    },
    {
      field: "initiatorDealBreakersCount",
      headerName: "Initiator Deal Breakers",
      valueGetter: (params, row) => formatDBKeys(row.dealBreakerReason?.initiator),
      flex:3
      // renderCell: (params) => (
      //   <Tooltip title={params.row.dealBreakerReason?.initiator.join(", ")}>
      //     <MDTypography>{params.row.initiatorDealBreakersCount}</MDTypography>
      //   </Tooltip>
      // ),
    },
    {
      field: "responderDealBreakersCount",
      headerName: "Responder Deal Breakers",
      valueGetter: (params, row) => formatDBKeys(row.dealBreakerReason?.responder),
      flex:3
      // renderCell: (params) => (
      //   <Tooltip title={params.row.dealBreakerReason?.responder.join(", ")}>
      //     <MDTypography>{params.row.responderDealBreakersCount}</MDTypography>
      //   </Tooltip>
      // ),
    },
    {
      field: "lastSuggestion",
      headerName: "Last Suggestion",
      valueGetter: (params, r) => formatDate(r.profile?.lastSuggestion),
      flex:1
    },
    {
      field: "comare",
      headerName: "Compare",
      renderCell: (params) => (
        <MDButton
          small
          variant="text"
          color="primary"
          onClick={() =>
            navigate(
              `/introductions/compare?initiatorProfileId=${params.row.initiatorProfileId}&responderProfileId=${params.row.responderProfileId}`
            )
          }
        >
          Compare
        </MDButton>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="End Users" />
      <Grid container gap={1}>
        <Grid size={12}>
          <SMEHeader
            formData={profile?.user}
            indications={[
              {
                title: "Gender:",
                value: profile?.profile?.attributesValues["gender"]?.[0],
              },
              {
                title: "Age:",
                value: profile?.user?.age,
              },
              {
                title: "Height:",
                value: formtHeight(profile?.profile?.attributesValues["height"]?.[0]),
              },
              {
                title: "Build:",
                value: profile?.profile?.attributesValues["bodyType"]?.[0],
              },
              {
                title: "Last Search:",
                value: lastSearch,
              },
            ]}
            saveProfile={() => {}}
          />
        </Grid>
        <TablePage
          title={"Potential Matches"}
          table={{
            columns,
            loadNext: getProfileMS,
            getRowId: (row) => row.responderProfileId,
          }}
          filters={[
            {
              label: "showAll",
              type: "switch",
            },
            {
              label: "showDealBreakers",
              multiple: true,
              options:attributes.filter(a=>a.settings?.filterByDealBreaker).map((a)=>({label:a.txt,key:a.name})),
            }
          ]}
        />
      </Grid>
    </DashboardLayout>
  );
}

export default EndUsersMatchScores;
